/* Halo Ring PDP logic — ported from the v5 DC script as a plain IIFE.
   Changes vs design: real variant picker (color+size from Shopify), real gallery
   swap, /cart/add.js wiring, fake aggregate-rating and placeholder reviews removed. */
(function () {
  'use strict';

  var sel = { o1: null, o2: null };
  var root, dsBase, cmpPrice;

  function q(s) { return document.querySelector(s); }
  function qa(s) { return Array.from(document.querySelectorAll(s)); }

  /* ---------- trust badges / payments / risk tiles ---------- */
  function proof() {
    var badges = q('[data-badges]');
    if (badges) {
      var items = [
        ['<path d="M12 3l7 3v5c0 4.4-3 8.3-7 10-4-1.7-7-5.6-7-10V6z"/><path d="M9.5 12.2l1.9 1.9 3.6-3.9" fill="none" stroke="#fff" stroke-width="2"/>', '60-day money back', 'Wrong size included'],
        ['<path d="M3 7h13l3 4h2v5h-2a2 2 0 1 1-4 0H9a2 2 0 1 1-4 0H3z"/>', 'Free shipping on orders over $50', 'Ships in 2–4 days'],
        ['<rect x="4" y="10" width="16" height="10" rx="2.5"/><path d="M8 10V8a4 4 0 0 1 8 0v2" fill="none" stroke="#12703E" stroke-width="2"/>', 'Secure checkout', 'Shop Pay · Apple Pay'],
        ['<circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8" fill="none" stroke="#fff" stroke-width="2"/>', 'HSA/FSA eligible', 'Use pre-tax dollars']
      ];
      badges.innerHTML = items.map(function (it) {
        return '<div style="display:flex;gap:11px;align-items:flex-start;padding:14px 15px;border-radius:16px;background:rgba(23,122,69,0.06);border:1px solid rgba(23,122,69,0.16);">'
          + '<svg width="20" height="20" viewBox="0 0 24 24" fill="#12703E" style="flex:none;margin-top:1px;">' + it[0] + '</svg>'
          + '<div><div style="font-family:Archivo,sans-serif;font-size:15.2px;font-weight:700;color:var(--cv-black);">' + it[1] + '</div>'
          + '<div style="font-size:14.5px;color:#6B6268;margin-top:3px;">' + it[2] + '</div></div></div>';
      }).join('');
    }
    var pay = q('[data-payments]');
    if (pay) pay.innerHTML = '<span style="font-family:Archivo,sans-serif;font-size:12px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#A9A29C;">We accept</span>'
      + ['Shop Pay', 'Apple Pay', 'Visa', 'Mastercard', 'Amex', 'PayPal'].map(function (t) {
          return '<span style="padding:6px 11px;border-radius:8px;background:var(--cv-white);border:1px solid rgba(42,40,40,0.1);font-family:Archivo,sans-serif;font-size:12.7px;font-weight:700;color:#6B6268;">' + t + '</span>';
        }).join('');
    var risk = q('[data-risk]');
    if (risk) risk.innerHTML = [['60', 'days to decide'], ['$0', 'to keep tracking'], ['2', 'full cycles of data']].map(function (it) {
      return '<div style="padding:22px 18px;border-radius:20px;background:rgba(249,247,240,0.12);border:1px solid rgba(249,247,240,0.2);text-align:center;">'
        + '<div style="font-family:Unbounded,sans-serif;font-weight:800;font-size:38px;letter-spacing:-0.03em;">' + it[0] + '</div>'
        + '<div style="font-family:Archivo,sans-serif;font-size:12px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:rgba(249,247,240,0.78);margin-top:8px;">' + it[1] + '</div></div>';
    }).join('');
  }

  /* ---------- six signals ---------- */
  function signals() {
    var host = q('[data-signals]');
    if (!host) return;
    var rows = [
      ['hormones', 'Temperature', '97.42 °F', '#B4638C', 'The overnight rise that follows ovulation. Progesterone’s signature.', 'time the month’s plan'],
      ['sleep', 'Sleep stages', '7h 42', '#7E6FC8', 'Deep sleep is when hormones are made and cleared.', 'push the week, or protect it'],
      ['hrv', 'Recovery &amp; HRV', '62 ms', '#5A6FFF', 'The resource everything else spends. When it drops, rhythm goes first.', 'dial the plan up or down'],
      ['energy', 'Daily readiness', '84', '#1EAA55', 'One honest morning read, folded into a number you can act on.', 'choose today’s version'],
      ['stress', 'Stress load', 'Elevated', '#C4564A', 'Sustained strain shifts cycle rhythm before you notice it.', 'Kai steps in early'],
      ['steps', 'Movement', '8,240', '#B08A3C', 'Enough supports hormone balance; too much works against it.', 'right-size activity']
    ];
    host.innerHTML = rows.map(function (r) {
      return '<div style="padding:24px;border-radius:24px;background:var(--cv-white);border:1px solid rgba(42,40,40,0.07);box-shadow:0 10px 26px rgba(42,40,40,0.05);">'
        + '<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">'
        + '<img src="' + dsBase.replace('cv-ds-hormones.png', 'cv-ds-' + r[0] + '.png') + '" alt="" style="width:53px;height:53px;object-fit:contain;">'
        + '<span style="font-family:Archivo,sans-serif;font-size:14px;font-weight:700;letter-spacing:0.05em;color:' + r[3] + ';">' + r[2] + '</span></div>'
        + '<div style="font-family:Unbounded,sans-serif;font-weight:700;font-size:19.6px;letter-spacing:-0.02em;margin-top:14px;">' + r[1] + '</div>'
        + '<div style="font-size:17.1px;line-height:1.6;color:#4A4658;margin-top:8px;">' + r[4] + '</div>'
        + '<div style="margin-top:12px;padding-top:10px;border-top:1px solid rgba(42,40,40,0.07);font-size:15.8px;color:#6B6268;">'
        + '<span style="font-family:Archivo,sans-serif;font-size:10.8px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:' + r[3] + ';">Kai uses it to</span> ' + r[5] + '</div>'
        + '</div>';
    }).join('');
  }

  /* ---------- gallery ---------- */
  function gallery() {
    var hero = q('[data-hero-img]');
    qa('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (hero) hero.src = b.getAttribute('data-thumb');
        qa('[data-thumb]').forEach(function (x) { x.style.border = '1px solid rgba(42,40,40,0.12)'; });
        b.style.border = '2px solid var(--cv-blue)';
      });
    });
  }

  /* ---------- variant picker ---------- */
  var variants = [];
  function paintPick() {
    qa('[data-opt1]').forEach(function (b) {
      var on = b.getAttribute('data-opt1') === sel.o1;
      b.style.background = on ? 'var(--cv-black)' : 'var(--cv-white)';
      b.style.color = on ? 'var(--cv-off-white)' : 'var(--cv-black)';
      b.style.borderColor = on ? 'var(--cv-black)' : 'rgba(42,40,40,0.16)';
    });
    qa('[data-opt2]').forEach(function (b) {
      var on = b.getAttribute('data-opt2') === sel.o2;
      b.style.background = on ? 'var(--cv-black)' : 'var(--cv-white)';
      b.style.color = on ? 'var(--cv-off-white)' : 'var(--cv-black)';
      b.style.borderColor = on ? 'var(--cv-black)' : 'rgba(42,40,40,0.16)';
    });
    syncAdd();
  }
  function resolveVariant() {
    if (sel.o1 == null || sel.o2 == null) return null;
    return variants.find(function (v) { return v.o1 === sel.o1 && v.o2 === sel.o2; }) || null;
  }
  function syncAdd() {
    var v = resolveVariant();
    var note = q('[data-add-note]');
    var add = q('[data-add]');
    if (note) {
      note.style.color = '#8A8378';
      note.textContent = v
        ? (v.available ? sel.o1 + ' · ' + sel.o2 + '. In stock, ships free in 2–4 days' : 'That combination is sold out. Try another.')
        : 'Pick a color and size to continue';
    }
    if (add) add.style.opacity = (v && v.available) ? '1' : '0.45';
  }
  function flashNote(msg) {
    var note = q('[data-add-note]');
    if (note) { note.textContent = msg; note.style.color = '#C4564A'; setTimeout(syncAdd, 1800); }
  }
  function addToCart(thenCheckout) {
    var v = resolveVariant();
    if (!v) { flashNote('Choose a color and size first'); return; }
    if (!v.available) { flashNote('That combination is sold out'); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = thenCheckout ? '/checkout' : '/cart';
    }).catch(function () { flashNote('Something went wrong. Try again.'); });
  }
  function picker() {
    var map = q('[data-variant-map]');
    if (map) { try { variants = JSON.parse(map.textContent); } catch (e) { variants = []; } }
    qa('[data-opt1]').forEach(function (b) { b.addEventListener('click', function () { sel.o1 = b.getAttribute('data-opt1'); paintPick(); }); });
    qa('[data-opt2]').forEach(function (b) { b.addEventListener('click', function () { sel.o2 = b.getAttribute('data-opt2'); paintPick(); }); });
    var add = q('[data-add]');
    if (add) add.addEventListener('click', function () { addToCart(false); });
    var ex = q('[data-express]');
    if (ex) ex.addEventListener('click', function () { addToCart(true); });
    syncAdd();
  }
  function sizeGuide() {
    var t = q('[data-size-toggle]');
    var p = q('[data-size-help]');
    if (!t || !p) return;
    t.addEventListener('click', function () {
      var open = p.style.display === 'block';
      p.style.display = open ? 'none' : 'block';
      t.textContent = open ? 'Sizing guide' : 'Hide guide';
    });
  }

  /* ---------- comparison ---------- */
  function compare() {
    var host = q('[data-cmp]');
    if (!host) return;
    function badge(bg, stroke, path) {
      return '<span style="display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:' + bg + ';">'
        + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="' + stroke + '" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg></span>';
    }
    var Y = badge('rgba(23,122,69,0.14)', '#12703E', '<path d="M20 6L9 17l-5-5"/>');
    var N = badge('rgba(196,86,74,0.13)', '#C4564A', '<path d="M18 6L6 18M6 6l12 12"/>');
    var P = '<span style="display:inline-flex;align-items:center;gap:5px;"><span style="display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:rgba(201,154,46,0.16);"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#A87C1A" stroke-width="3" stroke-linecap="round"><path d="M5 12h14"/></svg></span><span style="font-family:Archivo,sans-serif;font-size:12px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;color:#A87C1A;">Partly</span></span>';
    function big(t) { return '<strong style="font-family:Unbounded,sans-serif;font-weight:700;font-size:17.7px;">' + t + '</strong>'; }
    var rows = [
      ['Up-front price', big(cmpPrice), '$349–$549', '$249 monitor'],
      ['Ongoing cost to see your data', big('$0 · forever'), '$5.99/mo', 'Strips, every cycle'],
      ['Built around your cycle, not training load', Y, P, Y],
      ['Nothing to pee on, nothing to replace', Y, Y, N],
      ['A care team that revises your plan', Y, N, N],
      ['Battery life', big('8 days'), '~7 days', 'Phone-powered']
    ];
    host.innerHTML = rows.map(function (r, i) {
      return '<div style="display:grid;grid-template-columns:1.7fr 1fr 1fr 1fr;align-items:center;'
        + (i % 2 ? 'background:rgba(241,239,230,0.5);' : 'background:var(--cv-white);')
        + (i ? 'border-top:1px solid rgba(42,40,40,0.06);' : '') + '">'
        + '<div style="padding:16px 22px;font-size:17.7px;">' + r[0] + '</div>'
        + '<div style="padding:16px 12px;text-align:center;background:linear-gradient(180deg,rgba(90,111,255,0.07),rgba(90,111,255,0.04));border-left:1px solid rgba(90,111,255,0.14);border-right:1px solid rgba(90,111,255,0.14);">' + r[1] + '</div>'
        + '<div style="padding:16px 12px;text-align:center;font-size:16.5px;color:#8A8378;">' + r[2] + '</div>'
        + '<div style="padding:16px 12px;text-align:center;font-size:16.5px;color:#8A8378;">' + r[3] + '</div>'
        + '</div>';
    }).join('')
      + '<div style="padding:14px 22px;background:var(--cv-white);border-top:1px solid rgba(42,40,40,0.06);font-size:14px;line-height:1.6;color:#9C9890;">Competitor pricing as publicly listed at time of writing, subject to change.</div>';
  }

  /* ---------- lens switcher ---------- */
  function lenses() {
    var L = [
      { name: 'Period', stage: 'Period lens', color: '#E24D47', grad: 'linear-gradient(168deg,#E24D47 0%,#E8707A 100%)',
        head: 'The three days before, decoded.', sub: 'Patterns, never verdicts.',
        m: [['Skin temp', '−0.31', '°F'], ['Sleep', '6h 12', ''], ['HRV', '38', 'ms']],
        lines: ['The temperature drop the day before bleeding starts.', 'Which nights cramping actually cost you.', 'How hard the week is landing, so Kai can plan around it.'] },
      { name: 'Fertility', stage: 'Fertility lens', color: '#5A6FFF', grad: 'linear-gradient(168deg,var(--cv-blue) 0%,#7E82E8 100%)',
        head: 'Ovulation, without the 6am alarm.', sub: 'Patterns, never verdicts about your fertility.',
        m: [['Skin temp', '+0.62', '°F'], ['Sleep', '7h 42', ''], ['HRV', '52', 'ms']],
        lines: ['The sustained overnight rise that follows ovulation.', 'Whether recovery can support what this cycle is asking.', 'Your stress and readiness, read from your nights.'] },
      { name: 'Pregnancy', stage: 'Pregnancy lens', color: '#9686B9', grad: 'linear-gradient(168deg,#8E7FD8 0%,#A99ECF 100%)',
        head: 'Rest, when everything is changing.', sub: 'No scores, no flags, no verdicts.',
        m: [['Resting HR', '74', 'bpm'], ['Sleep', '6h 48', ''], ['HRV', '44', 'ms']],
        lines: ['The quiet climb that comes with growing blood volume.', 'Where the wake-ups cluster, so you can plan around them.', 'How your nights add up, as context, never a diagnosis.'] },
      { name: 'Postpartum', stage: 'Postpartum lens', color: '#6FA86C', grad: 'linear-gradient(168deg,#3F7A5C 0%,#6FA86C 100%)',
        head: 'Recovery, measured in fragments.', sub: 'Sleep in 90-minute pieces still counts.',
        m: [['Sleep', '5h 34', ''], ['HRV', '41', 'ms'], ['Skin temp', 'Flat', '']],
        lines: ['Total rest across the night, feeds included.', 'How far into the tank you are, before you crash.', 'The first quiet sign hormones are cycling again.'] },
      { name: 'Menopause', stage: 'Menopause lens', color: '#E8B44A', grad: 'linear-gradient(168deg,#D89A2E 0%,#E8B44A 100%)',
        head: 'The 3am wake-up, explained.', sub: 'You are not imagining it.',
        m: [['Night spikes', '3', '×'], ['Sleep', '5h 58', ''], ['HRV', '35', 'ms']],
        lines: ['Flashes mapped to the hour they happen.', 'How much the heat is really costing you.', 'How the broken nights show up in next-day recovery.'] }
    ];
    var pills = q('[data-lens-pills]');
    if (!pills) return;
    function set(s, txt) { var el = q(s); if (el) el.textContent = txt; }
    function paint(i) {
      var x = L[i];
      pills.innerHTML = L.map(function (l, j) {
        var on = j === i;
        return '<button data-lp="' + j + '" style="padding:11px 20px;border-radius:999px;cursor:pointer;font-family:Archivo,sans-serif;font-size:14px;font-weight:700;letter-spacing:0.11em;text-transform:uppercase;'
          + (on ? 'background:' + l.color + ';color:var(--cv-off-white);border:1.5px solid ' + l.color + ';box-shadow:0 10px 24px ' + l.color + '4D;'
                : 'background:transparent;color:#4A4658;border:1.5px solid rgba(42,40,40,0.14);') + '">' + l.name + '</button>';
      }).join('');
      pills.querySelectorAll('[data-lp]').forEach(function (b) { b.addEventListener('click', function () { paint(Number(b.getAttribute('data-lp'))); }); });
      var wash = q('[data-lens-wash]');
      if (wash) wash.style.setProperty('--wash', x.grad);
      set('[data-lens-stage]', x.stage);
      set('[data-lens-head]', x.head);
      set('[data-lens-sub]', x.sub);
      var mx = q('[data-lens-metrics]');
      if (mx) mx.innerHTML = x.m.map(function (m) {
        return '<div style="padding:13px 14px;border-radius:16px;background:rgba(42,40,40,0.04);border:1px solid rgba(42,40,40,0.07);">'
          + '<div style="font-family:Archivo,sans-serif;font-size:10.1px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#9C9890;">' + m[0] + '</div>'
          + '<div style="display:flex;align-items:baseline;gap:3px;margin-top:6px;"><span style="font-family:Unbounded,sans-serif;font-weight:700;font-size:21.6px;">' + m[1] + '</span>'
          + (m[2] ? '<span style="font-size:12.7px;color:#9C9890;">' + m[2] + '</span>' : '') + '</div></div>';
      }).join('');
      var lines = q('[data-lens-lines]');
      if (lines) lines.innerHTML = x.lines.map(function (t) {
        return '<div style="display:flex;gap:11px;align-items:flex-start;"><span style="width:7px;height:7px;border-radius:50%;background:' + x.color + ';margin-top:7px;flex:none;"></span>'
          + '<span style="font-size:17.1px;line-height:1.55;color:#4A4658;">' + t + '</span></div>';
      }).join('');
    }
    paint(1);
  }

  /* ---------- FAQ ---------- */
  function faq() {
    var host = q('[data-faq]');
    if (!host) return;
    var qs = [
      ['Do I have to pay a subscription?', 'No. Buy the ring once and track all six signals free, forever. Full history, no paywall. Kai’s AI advising is the only optional add-on, and you can try her before committing.'],
      ['How is this different from Oura?', 'Oura is a general wellness tracker that puts most insights behind a monthly membership. The Halo is calibrated for every phase of women’s health, tracking is always free, and your care team turns the data into a plan instead of more charts.'],
      ['How do I pick a size?', 'Measure at the end of the day when fingers are largest, wear it on the index or middle finger of your non-dominant hand, and size up if you’re between. The 60-day guarantee covers a free exchange if the fit is wrong.'],
      ['Battery and build?', 'Titanium, water-safe to 100m, about 4 grams, and around eight days on a charge, depending on use. Most people forget they’re wearing it within a day.'],
      ['Do I need the supplements?', 'No. The ring and free tracking work on their own. If you add Kai, she may suggest a personalized pack based on your signals. It’s entirely your choice.'],
      ['Is my data private?', 'Encrypted end to end, stored on secure servers, never sold or shared. You own your data.']
    ];
    host.innerHTML = qs.map(function (it) {
      return '<details style="border-radius:20px;background:var(--cv-white);border:1px solid rgba(42,40,40,0.08);padding:20px 24px;cursor:pointer;">'
        + '<summary style="font-family:Archivo,sans-serif;font-size:18.9px;font-weight:700;cursor:pointer;">' + it[0] + '</summary>'
        + '<div style="font-size:18.4px;line-height:1.65;color:#4A4658;margin-top:12px;">' + it[1] + '</div></details>';
    }).join('');
  }

  document.addEventListener('DOMContentLoaded', function () {
    root = q('[data-pdp-root]');
    dsBase = root ? root.getAttribute('data-ds-base') : '';
    cmpPrice = (root && root.getAttribute('data-cmp-price')) || '$250';
    proof();
    signals();
    gallery();
    picker();
    sizeGuide();
    compare();
    lenses();
    faq();
  });
})();
